module.exports = __webpack_public_path__ + "img/404.ff2ab97c.svg";